import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {
  GetArticleIdByManufacturerNumberAndManufacturerIdResponse,
  GetArticleResponse,
  basePriceSourceObject,
  salesPriceCalculationObject,
} from '../types';

const articleMock: GetArticleResponse = {
  id: 'test-article-id',
  warehouseId: 'test-warehouse-id',
  supplierId: 'test-supplier-id',
  manufacturerId: 'test-manufacturer-id',
  name: 'Test Article V3',
  description: 'Test article description',
  manufacturerNumber: 'TEST123',
  manufacturerName: 'Test Manufacturer',
  handlingUnit: 'pcs',
  dispensingUnit: 1,
  vatType: 'STANDARD',
  storageLocation: 'A1-B2',
  treeFolder: {leafId: 'test-leaf-id'},
  supplierDiscountGroupId: undefined,
  marketingCode: undefined,
  workItemGroupId: undefined,
  pricesSettings: {
    avgPurchasePriceWithoutVat: 0,
    avgPurchasePriceWithVat: 0,
    lastPurchasePriceWithoutVat: 0,
    lastPurchasePriceWithVat: 0,
    recommendedPurchasePriceWithoutVat: 0,
    recommendedPurchasePriceWithVat: 0,
    purchasePriceDefSupplierWithoutVat: 0,
    purchasePriceDefSupplierWithVat: 0,
    salesPriceCalculation: salesPriceCalculationObject.MANUAL,
    basePriceSource: basePriceSourceObject.MANUAL,
    unitSalesPriceWithVat: false,
  },
  dispensingPrices: {
    basePriceWithoutVat: 0,
    basePriceWithVat: 0,
    saleBasePriceWithoutVat: 0,
    saleBasePriceWithVat: 0,
    saleBaseProfit: 0,
    saleBaseMarginPercent: 100,
    saleBaseMarkUpPercent: 100,
    warrantyPriceWithoutVat: 0,
    warrantyPriceWithVat: 0,
    warrantyProfit: 0,
    warrantyMarginPercent: 100,
    warrantyMarkUpPercent: 100,
  },
  isOneTimeSale: false,
  stockManagement: {
    stockManagementType: 'MANUAL',
  },
  isTemporary: false,
  isRemovable: true,
  isHandlingUnitEditable: true,
  created: '2024-01-01T00:00:00.000Z',
  createdBy: 'test-user',
  updated: '2024-01-01T00:00:00.000Z',
  updatedBy: 'test-user',
};

const getArticleIdByManufacturerNumberAndManufacturerIdResponseMock: GetArticleIdByManufacturerNumberAndManufacturerIdResponse =
  {
    articleId: '1c576838-aff5-4fcb-b99e-2dbf33757527',
    name: null,
    measurementUnitId: null,
  };

const getArticleIdByManufacturerNumberAndManufacturerIdResponseInterceptor = (
  server: SetupServerApi,
  doesArticleExist: boolean
) =>
  server.use(
    http.get('*/warehouse/v2/warehouse/*/manufacturer-id/*/manufacturer-number*', () => {
      if (doesArticleExist) {
        return HttpResponse.json(getArticleIdByManufacturerNumberAndManufacturerIdResponseMock);
      }
      return HttpResponse.json({articleId: null, name: null, measurementUnitId: null});
    })
  );

const postArticleResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.post('*/warehouse/v1/warehouse/*/article', () =>
      HttpResponse.json({articleId: '1c576838-aff5-4fcb-b99e-2dbf33757527'})
    )
  );

const putSupplierArticlePromptValidationInterceptor = (server: SetupServerApi) =>
  server.use(
    http.put('*/warehouse/v1/supplier-article-prompt-validation', () =>
      HttpResponse.json({isChanged: false})
    )
  );

const getArticleResponseInterceptor = (
  server: SetupServerApi,
  mockData: GetArticleResponse = articleMock
) =>
  server.use(http.get('*/warehouse/v5/warehouse/*/article/*', () => HttpResponse.json(mockData)));

export const metadaWarehouseArticleApiMock = {
  articleMock,
  getArticleIdByManufacturerNumberAndManufacturerIdResponseMock,
  getArticleIdByManufacturerNumberAndManufacturerIdResponseInterceptor,
  getArticleResponseInterceptor,
  postArticleResponseInterceptor,
  putSupplierArticlePromptValidationInterceptor,
};
